const apiGtwUrl = window.runtime.API_URL;
const assetsRoot = window.runtime.ASSETS_URL;

export default {
  apiBaseUri: apiGtwUrl + '/public/api/v1',
  apiBaseUriLegacy: apiGtwUrl + '/front',
  assetsRoot: assetsRoot,
  geolocMaxAccuracy: 100000,
  screenWidth: 1920,
  screenHeight: 1080,
  googleGeolocateApiKey: 'AIzaSyB_4A7dtQrMHp_NvYCpFw4C7LBOW-bGFUI',
  gpsSecret: 'dfg56dfg6dg',
  timeBeforeFade: 2000,
  dureeSeance: 6,
  dureeAchat: 1,
};
